/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAktResponseBaseLocation
 */
export interface GetAktResponseBaseLocation {
    /**
     * 
     * @type {string}
     * @memberof GetAktResponseBaseLocation
     */
    displayName?: string;
    /**
     * 
     * @type {number}
     * @memberof GetAktResponseBaseLocation
     */
    id?: number;
}

export function GetAktResponseBaseLocationFromJSON(json: any): GetAktResponseBaseLocation {
    return GetAktResponseBaseLocationFromJSONTyped(json, false);
}

export function GetAktResponseBaseLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAktResponseBaseLocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function GetAktResponseBaseLocationToJSON(value?: GetAktResponseBaseLocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'displayName': value.displayName,
        'id': value.id,
    };
}


